import { IResponseModel } from "../../IResponseModel";

export class DeleteServerResponse implements IResponseModel {
}